import React from 'react'

import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  className?: string
}

const PremiumLabel = ({ className = '' }: Props) => {
  return (
    <S.Label className={className}>
      <S.Logo src="/img/favicon_trane.svg" />
      Premium
    </S.Label>
  )
}

export default PremiumLabel

const S = {
  Label: styled.div.withConfig({
    shouldForwardProp: (prop) => !['src'].includes(prop)
  })`
    display: inline-block;
    color: ${color('tagText')};
    background-color: ${color('tagBackground')};
    border: 1px solid ${color('tagBorder')};
    border-radius: 3px;
    padding: 3px 8px;
    font-weight: bold;
    white-space: nowrap;
  `,
  Logo: styled.img`
    height: 12px;
    margin-right: 5px;
  `
}
